import { fg } from '@atlassian/jira-feature-gating';

const JiraTimelineIssueSearchErrorBreakdownRelayProvider = {
	get(): boolean {
		return fg('jira_timeline_issue_search_error_breakdown');
	},
};

export default JiraTimelineIssueSearchErrorBreakdownRelayProvider;
